import { render, staticRenderFns } from "./Menu-short.vue?vue&type=template&id=f36af058&"
import script from "./Menu-short.vue?vue&type=script&lang=ts&"
export * from "./Menu-short.vue?vue&type=script&lang=ts&"
import style0 from "./Menu-short.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports